export enum ColorVariables {
  RED100 = "var(--p-color-red-100)",
  RED200 = "var(--p-color-red-200)",
  RED300 = "var(--p-color-red-300)",
  RED550 = "var(--p-color-red-550)",
  RED600 = "var(--p-color-red-600)",
  RED800 = "var(--p-color-red-800)",
  RED900 = "var(--p-color-red-900)",
  PURPLE550 = "var(--p-color-purple-550)",
  PURPLE600 = "var(--p-color-purple-600)",
  PURPLE800 = "var(--p-color-purple-800)",
  PURPLE900 = "var(--p-color-purple-900)",
  GREEN550 = "var(--p-color-green-550)",
  GREEN600 = "var(--p-color-green-600)",
  GREEN700 = "var(--p-color-green-700)",
  GREEN800 = "var(--p-color-green-800)",
  GREEN900 = "var(--p-color-green-900)",
  BLUE500 = "var(--p-color-blue-500)",
  BLUE550 = "var(--p-color-blue-550)",
  BLUE600 = "var(--p-color-blue-600)",
  BLUE700 = "var(--p-color-blue-700)",
  BLUE800 = "var(--p-color-blue-800)",
  BLUE900 = "var(--p-color-blue-900)",
  GREY100 = "var(--p-color-grey-100)",
  GREY200 = "var(--p-color-grey-200)",
  GREY300 = "var(--p-color-grey-300)",
  GREY400 = "var(--p-color-grey-400)",
  GREY500 = "var(--p-color-grey-500)",
  GREY600 = "var(--p-color-grey-600)",
  GREY700 = "var(--p-color-grey-700)",
  GREY800 = "var(--p-color-grey-800)",
  GREY900 = "var(--p-color-grey-900)",
}

export const HIGHCHART_MONOCHROME_COLORS = [
  ColorVariables.RED550,
  ColorVariables.RED600,
  ColorVariables.RED800,
  ColorVariables.RED900,
  ColorVariables.PURPLE550,
  ColorVariables.PURPLE600,
  ColorVariables.PURPLE800,
  ColorVariables.PURPLE900,
];

export const HIGHCHART_CATEGORICAL_COLORS = [
  ColorVariables.PURPLE800,
  ColorVariables.RED550,
  ColorVariables.RED600,
  ColorVariables.PURPLE550,
  ColorVariables.RED800,
  ColorVariables.GREY500,
  ColorVariables.BLUE700,
  ColorVariables.GREEN550,
  ColorVariables.PURPLE600,
  ColorVariables.BLUE500,
  ColorVariables.GREEN700,
  ColorVariables.GREY700,
];

export enum GeneralChartColors {
  AnnualGrossIncomeColumn = ColorVariables.GREY600,
  AxisLine = "#c4a587",
  Band = "rgba(25, 25, 25, 0.1)",
  Border = "#fff",
  ColumnDefault = "#268c99",
  GridLine = "#D9D9D9",
  NeedsDefault = "#7cb5ec",
  AxisText = "#666",
}

export enum RangedNeedsColors {
  DataLabel = "#191919",
  AreaMarkerFill = "white",
  AreaFill = "#E8F3E1",
  AreaStroke = ColorVariables.GREEN550,
  ColumnFill = ColorVariables.RED550,
}
